import "./js/main";
import "./lib/easing/easing";
import "./lib/owlcarousel/owl.carousel";
import "./lib/wow/wow";